import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Checkbox,
    ListItemText,
} from '@mui/material';
import './StatusMultiSelect.scss';

const MenuProps = {
    PopoverClasses: {
        paper: 'fixed-top-position-popover',
    },
};

/**
 * @param {{
 *  onStatusChange: (selectedStatuses: string[]) => void;
 *  defaultStatuses?: string[];
 *  allStatuses: string[]; 
 *  placeholder?: string;
 * }} param0
 * */
const StatusMultiSelect = ({
    allStatuses, defaultStatuses, onStatusChange, placeholder = '',
}) => {
    const intitialStatuses = defaultStatuses || allStatuses;
    const [statuses, setStatuses] = useState(intitialStatuses);
    const { t } = useTranslation('status');

    useEffect(() => {
        setStatuses(intitialStatuses);
        onStatusChange(intitialStatuses);
    }, [JSON.stringify(allStatuses)]);

    /** @type {(event: import('react').ChangeEvent<{ name?: string | undefined; value: string|[]; }>) => void}} */
    const handleChange = (event) => {
        const { target: { value } } = event;
        const updatedStatus = typeof value === 'string' ? value.split(',') : value;
        setStatuses(updatedStatus);
        onStatusChange(updatedStatus);
    };

    return (
        <div className="core--select-multi-status">
            {
                <FormControl
                    className="select-multi-status-form"
                    variant="outlined"
                >
                    <InputLabel>{placeholder}</InputLabel>
                    <Select
                        className='core--select-multi-status-input'
                        multiple
                        value={statuses}
                        // @ts-ignore
                        onChange={handleChange}
                        // @ts-ignore
                        renderValue={(/** @type {string[]} */selected) => selected.map((s) => t(s)).join(', ')}
                        MenuProps={MenuProps}
                    >
                        {allStatuses.map((s) => (
                            <MenuItem
                                key={s}
                                value={s}
                            >
                                <Checkbox color="primary" checked={statuses.indexOf(s) > -1} />
                                <ListItemText primary={t(s)} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>
    );
};

export default StatusMultiSelect;
